import doesActiveExperiencesInclude from "./doesActiveExperiencesInclude";
import type { MailboxInfo } from "owa-client-types";

/**
 * Checks to see if the user has Teams Premium Virtual Appointments license
 * @returns true if the user has Teams Premium Virtual Appointments license
 */
export default function isTeamsProVirtualAppointmentsUser(mailboxInfo?: MailboxInfo): boolean {
    return doesActiveExperiencesInclude("TeamsProVirtualAppointments", mailboxInfo);
}
